import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useEffect, useState, } from 'preact/compat';
import DatePicker from 'react-datepicker';
import { useController, useFormContext, } from 'react-hook-form';
import merge from 'lodash.merge';
import { clsx } from 'clsx';
import { format, setHours, setMinutes } from 'date-fns';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormError from '@enquiryForm/components/FormError';
import defaultDatepickerProps from './defaultProps';
import DatepickerHeader from './Header';
function DatepickerInput(props) {
    const { labelAttrs, inputAttrs, type, forceError, } = props;
    const { name, className: forwardedInputClassName, dateFormat, timeFormat, } = inputAttrs;
    const { control, setValue } = useFormContext();
    const { field: { onChange, value }, fieldState: { error, invalid, isTouched }, } = useController({
        name,
        control,
    });
    const [selectedValue, setSelectedValue] = useState(value ?? null);
    const inputClassName = clsx(['form__control', type], forwardedInputClassName, { invalid: invalid && isTouched });
    const datepickerHeaderElement = useCallback((headerProps) => (_jsx(DatepickerHeader, { ...headerProps, maybeMinDate: inputAttrs.minDate ?? undefined, maybeMaxDate: inputAttrs.maxDate ?? undefined })), [defaultDatepickerProps]);
    const mergedInputProps = merge({}, defaultDatepickerProps, {
        className: inputClassName,
        onChange: setSelectedValue,
        selected: selectedValue,
        renderCustomHeader: (type === 'date') ? datepickerHeaderElement : null,
    }, (type === 'date') ? {} : {
        minTime: setHours(setMinutes(new Date(), 0), 9),
        maxTime: setHours(setMinutes(new Date(), 0), 22),
    }, inputAttrs);
    const handleSelectedValueChange = useCallback(() => {
        if (selectedValue) {
            onChange(format(selectedValue, `${dateFormat ?? (timeFormat ?? 'yyyy-MM-dd')}`));
            setValue(name, format(selectedValue, `${dateFormat ?? (timeFormat ?? 'yyyy-MM-dd')}`), { shouldTouch: true, shouldValidate: true });
        }
    }, [dateFormat, onChange, selectedValue, timeFormat]);
    useEffect(handleSelectedValueChange, [handleSelectedValueChange, selectedValue]);
    return (_jsxs(FormGroup, { className: error ? 'form__group--error' : '', children: [_jsx(FormLabel, { ...labelAttrs }), _jsx(DatePicker, { ...mergedInputProps }), (error && (isTouched || forceError)) && (_jsx(FormError, { children: error?.message }))] }));
}
DatepickerInput.defaultProps = {
    type: 'date',
    forceError: false,
};
export default DatepickerInput;
